import { OuterWrapper, Wrapper } from './Footer.styled';

export default function Footer() {
  return (
    <OuterWrapper>
      <Wrapper>{`© 2022-1 WEB VENTURE Team 4`}</Wrapper>
    </OuterWrapper>
  );
}
